import { render } from "./LotsTable.vue?vue&type=template&id=9ca83d94&scoped=true&ts=true&lang=pug"
import script from "./LotsTable.vue?vue&type=script&lang=ts&setup=true"
export * from "./LotsTable.vue?vue&type=script&lang=ts&setup=true"

import "./LotsTable.vue?vue&type=style&index=0&id=9ca83d94&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ca83d94"]])

export default __exports__